import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import brandsTableData from "./data/brandsTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddBrandModal from "components/AddBrandModal";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CircularProgress, Backdrop } from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";

function Brands() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); // Add current user state
  const [loading, setLoading] = useState(true);

  // Modify modal opening logic
  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };
  useEffect(() => {

    fetchUsers();

  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/administrator/brands", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUsers(data.data || []);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  const { columns, rows } = brandsTableData(users, handleEditClick, fetchUsers);

  const filteredRows = rows.filter(
    (row) =>
      (row.author?.props?.name?.toLowerCase() || "").includes(search.toLowerCase()) ||
      (row.author?.props?.email?.toLowerCase() || "").includes(search.toLowerCase())
  );
  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث أو عدد الصفوف
  }, [search, rowsPerPage]);
  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AddBrandModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setCurrentUser(null);
        }}
        onUserAdded={fetchUsers}
        initialData={currentUser} // Pass current user data
      />

      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              كل الماركات
            </MDTypography>

            <MDButton
              variant="contained"
              color="white"
              startIcon={<AddIcon />}
              sx={{ color: "white" }}
              onClick={() => setModalOpen(true)}
            >
              ماركة جديدة
            </MDButton>
          </MDBox>

          <MDBox pt={3} px={2}>
            <TextField
              fullWidth
              label="بحث بالاسم "
              variant="outlined"
              size="small"
              sx={{ mb: 3 }}
              onChange={(e) => setSearch(e.target.value)}
            />
            <MDBox mb={2} display="flex">
              <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
            </MDBox>
            <DataTable
              table={{ columns, rows: paginatedRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={true}
              noEndBorder
              sx={{
                "& .MuiTable-root": { minWidth: 1000 },
                "& .MuiTableCell-root": {
                  py: 1.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                },
                "& .MuiTableHead-root": {
                  backgroundColor: (theme) => theme.palette.grey[100],
                },
              }}
            />
          </MDBox>
          <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
            <MDButton
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
              disabled={page === 0}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowBackIcon />
            </MDButton>

            <MDTypography
              variant="button"
              color="text"
              sx={{
                display: "flex",
                alignItems: "center",
                mx: 3,
                fontWeight: "bold",
              }}
            >
              الصفحة {page + 1} من {Math.ceil(filteredRows.length / rowsPerPage)}
            </MDTypography>

            <MDButton
              onClick={() =>
                setPage((prev) =>
                  (prev + 1) * rowsPerPage >= filteredRows.length ? prev : prev + 1
                )
              }
              disabled={(page + 1) * rowsPerPage >= filteredRows.length}
              sx={{
                background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                minWidth: "50px",
                mx: 1,
                "&:hover": {
                  background: "linear-gradient(90deg, #b6842f, #d39d45)",
                },
              }}
            >
              <ArrowForwardIcon />
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>

    </>
  );
}

export default Brands;
